import { useState } from "react";
import { Link } from "react-router";
import { NewProjectDialog } from "../components/Dialogs.tsx";
import { Empty, ErrorBox, Loading } from "../components/ui.tsx";
import { useApi } from "../lib/api.ts";
import type { Overview } from "../lib/types.ts";
import { channelUrl, StateCount } from "./Overview.tsx";
import type { SessionState, Settings } from "../lib/types.ts";

export function Projects() {
  const overview = useApi<Overview>("/api/overview");
  const settings = useApi<Settings>("/api/settings");
  const [creating, setCreating] = useState(false);
  if (!overview.data) return overview.error ? <ErrorBox error={overview.error} /> : <Loading />;
  const projects = overview.data.projects;
  return (
    <>
      <div className="pagehead">
        <div>
          <h1>Projects</h1>
          <div className="sub">Each project is a git checkout under the projects root and a channel in Discord.</div>
        </div>
        <button className="btn primary" onClick={() => setCreating(true)}>
          New project
        </button>
      </div>
      {projects.length === 0 ? (
        <div className="card">
          <Empty title="No projects yet">
            <button className="btn primary" onClick={() => setCreating(true)}>
              Create a project
            </button>
          </Empty>
        </div>
      ) : (
        <div className="card flush">
          <div className="tablewrap">
            <table className="table">
              <thead>
                <tr>
                  <th>Project</th>
                  <th>Sessions</th>
                  <th>Discord</th>
                  <th>Defaults</th>
                  <th>Folder</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((p) => {
                  const ch = channelUrl(settings.data?.["discord.guild_id"], p.channelId);
                  const states = (Object.entries(p.states) as [SessionState, number][]).filter(([, n]) => n > 0);
                  return (
                    <tr key={p.id}>
                      <td>
                        <Link to={`/projects/${p.slug}`}>
                          <b>{p.name}</b>
                        </Link>
                        <div className="muted small mono">{p.slug}</div>
                      </td>
                      <td>
                        <div className="row">{states.length ? states.map(([s, n]) => <StateCount key={s} state={s} n={n} />) : <span className="muted small">none</span>}</div>
                      </td>
                      <td>
                        {ch ? (
                          <a href={ch} target="_blank" rel="noreferrer">
                            #{p.slug} ↗
                          </a>
                        ) : (
                          <span className="muted small">{p.channelId ? `#${p.slug}` : "no channel"}</span>
                        )}
                      </td>
                      <td className="small">
                        <span className="mono">{p.defaultModel ?? "default"}</span> · {p.permissionMode} · max {p.maxSessions}
                      </td>
                      <td className="mono small muted">{p.rootPath}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {creating && <NewProjectDialog onClose={() => setCreating(false)} />}
    </>
  );
}
